import { Component, OnInit } from '@angular/core';
import { TeamSlider, TestimonialSlider } from '../../shared/data/slider';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-career', 
  templateUrl: './career.component.html'
})
export class CareerComponent implements OnInit {

  // positions: string[] = ['Developer', 'Designer', 'Manager', 'QA Tester','HR', 'Other'];
  positions: string[] = ['Developer', 'Designer', 'Manager', 'QA Tester', 'HR', 'Intern', 
  'Product Manager', 'Technical Writer', 'Data Analyst', 'DevOps Engineer',
  'UX/UI Designer', 'Software Architect', 'Business Analyst', 'Sales Engineer',
   'Customer Support Specialist', 'Marketing Specialist', 'Financial Analyst', 
   'Security Analyst', 'Content Creator', 
      'Business Development Associate', 'Customer Experience Manager', 'IT Consultant', 'Enterprise Architect', 'Cloud Solutions Architect',
         'UI/UX Developer', 'Frontend Developer', 'Backend Developer', 'Full Stack Developer', 'Mobile Developer', 'Web Developer', 
         'Social Media Manager', 'Content Moderator', 'Data Entry Clerk', 'Technical Trainer', 'Instructional Designer', 
         'E-learning Developer', 'Data Entry Operator', 
         
         'Other'];
         Experiences: string[] =  ["Entry Level", "Junior", "Mid Level", "Senior", "Lead", "Expert"];
         
  applicant = {
    name: '',
    email: '',
    phone: '',
    message:"",
    subject: 'Lead From career page Itwebinfo.com',
    position: this.positions[0],
    Experience: this.Experiences[0],
    subject_message:"",
    currentcity: ""
  };

  constructor(private apiService: ApiService ,  private toastrService: ToastrService) { }

  ngOnInit(): void {
  }

  onSubmit() {
    // console.log('Application Submitted:', this.applicant);
    // Here you can add code to handle the form submission, e.g., send data to a server
    // const data = { key: 'value' }; // Replace with your actual data
    const data = this.applicant

    this.apiService.postData(data, 'carer_api.php').subscribe(response => {
      
      this.applicant.name= '';
    this.applicant.email= '';
    this.applicant.phone= '';
    this.applicant.message= '';
    this.applicant.position= '';
    this.applicant.Experience= '';
    this.applicant.subject_message= 'Thank you for Contacting Us, Our team will get back to you shortly';

      // console.log('POST response', response);
      this.toastrService.success('Thankyou for Conact with Us, Team will Be Connect you As Soon As Posiable  .');
    }, error => {
      this.toastrService.success('Thankyou for Conact with Us.');
      console.error('POST error', error);
    });

  }

  public TeamSliderConfig: any = TeamSlider;
  public TestimonialSliderConfig: any = TestimonialSlider;


    public sliders = [{
    title: 'ANDROID APP DEVELOPMENT    ',
    subTitle: 'Welcome to Aquila , a leading provider of cutting-edge Android app development solutions. Founded with a passion for innovation and a commitment to excellence, we strive to empower businesses and individuals with transformative mobile experiences that drive success in the digital world. ',
    image: 'assets/images/slider/1.jpg'
  }];
   // Blog
   public blogs = [{
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-coding-software-developer-work-augmented-reality-dashboard-computer-icons-scrum.jpg',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
    date: 'March 30, 2024',
    title: 'Unleashing Creativity with Android Development: Building Innovative Mobile Experiences,',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-website-designer-working-with-the-new-computer-interface-as-desi.jpg',

    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',

    date: 'March 30, 2024',
    title: 'Elevate Your Travel Experience with Our Hotel Booking System    ',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-website-designer-working-with-the-new-computer-interface-as-desi.jpg',
    date: 'March 30, 2024',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
   
    title: 'The Role of Artificial Intelligence in Modern Business Solutions    ',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-programmer-working-software-development-coding-technologies-website-design-technology-concept.jpg',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
    date: 'March 30, 2024',
    title: 'Elevate Your Online Presence with Professional Web Development Services',
    by: 'John Dio'
  }]


}
